import React from "react";
import ModalComponent from "./modal.component";

export default function ModalContainer({ isOpen, handleClose, ...props }) {
  return (
    <ModalComponent isOpen={isOpen} handleClose={handleClose} {...props} />
  );
}
